module.exports = __webpack_public_path__ + "img/groups1.a118b7ab.jpg";